import {AnnotationConfiguration,InstanceContainer } from './validator.interface';

export const defaultContainer:
    {
        get<T>(instanceFunc: any): InstanceContainer,
        addAnnotation(instanceFunc: any, annotationConfiguration: AnnotationConfiguration): void,
        addInstanceContainer(instanceFunc: any): void
    } = new (class {
        private instances: InstanceContainer[] = [];

        get<T>(instanceFunc: any): InstanceContainer {
            let instance: InstanceContainer = this.instances.filter(instance => instance.instance === instanceFunc)[0];
            return instance;
        }

        addInstanceContainer(instanceFunc: any): void {
            let instance: InstanceContainer = this.instances.filter(instance => instance.instance === instanceFunc)[0];
            if (!instance) {
                instance.instance = instanceFunc, instance.propertyAnnotations = [];
                this.instances.push(instance);
            }
        }

        addAnnotation(instanceFunc: any, annotationConfiguration: AnnotationConfiguration): void {
            let instance = this.instances.filter(instance => instance.instance === instanceFunc)[0];
            if (instance)
                instance.propertyAnnotations.push(annotationConfiguration);
            else {
                let instance: InstanceContainer = {
                    instance: instanceFunc, propertyAnnotations: [annotationConfiguration]
                }
                this.instances.push(instance);
            }
        }

    })();


// WEBPACK FOOTER //
// ./node_modules/@rx/core/defaultContainer.ts